export class ContentTypeDispatcher {
    static $inject = ['props'];
    constructor(props) {
        Object.assign(this, props);
    }
}
export class ContentTypeAddContent extends ContentTypeDispatcher {
    static $inject = ['props'];
    constructor(props) {
        super(props);
        Object.assign(this, props);
    }
}
